import { Dispatch, SetStateAction, useState } from "react";
import Input from "../lib/Input";
import CostColumns from "../lib/CostColumns";
import OperationLayout from "../lib/OperationLayout";
import useOperationContext from "../lib/useOperationContext";
import OperationHeader from "../lib/OperationHeader";
import { hasSomeValidationErrorsInFields } from "../lib/getValidationErrors";
import { useReuseFieldValue } from "../lib/useReuseFieldValue";
import { Operation } from "../lib/types";

export default function ExpenseNonRecurring() {
  const { operationData: data } = useOperationContext();
  const { id, validation_errors } = data;
  const expandByDefault = hasSomeValidationErrorsInFields({
    errors: validation_errors,
    expandedPanelFields: ["supplier", "lead_time", "markup"],
  });
  const [expand, setExpand] = useState(expandByDefault);

  return (
    <OperationLayout
      id={id as string}
      left={<Left operation={data} expand={expand} setExpand={setExpand} />}
      right={<Right />}
    />
  );
}

function Left({
  operation,
  expand,
  setExpand,
}: {
  operation: Operation;
  expand: boolean;
  setExpand: Dispatch<SetStateAction<boolean>>;
}) {
  const { markedForReuse, toggleFieldReuse } = useReuseFieldValue({
    operationType: operation.type,
    operationName: operation.name,
    keyPath: ["lead_time"],
  });

  return (
    <div className="w-full flex flex-col p-2 pb-1 gap-2 items-start">
      <OperationHeader
        operation={operation}
        expand={expand}
        setExpand={setExpand}
      >
        <Input label="Cost" keyPath={["cost"]} unit="currency" />
      </OperationHeader>
      {expand && (
        <div className="w-full flex justify-between">
          <div className="flex gap-2">
            <Input label="Supplier" keyPath={["supplier"]} />
            <Input
              label="Lead time"
              keyPath={["lead_time"]}
              unit="time"
              markedForReuse={markedForReuse}
              toggleFieldReuse={toggleFieldReuse}
            />
          </div>
          <Input label="Markup" keyPath={["markup"]} suffix="%" width={60} />
        </div>
      )}
    </div>
  );
}

function Right() {
  return <CostColumns />;
}
